// extracted by mini-css-extract-plugin
export default {"container":"FormAddingServiceData_container__7tmlp","containerOpacity":"FormAddingServiceData_containerOpacity__DkSvD"};